// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgSpeakerOn24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M17.5398 4.39977C17.8327 4.10692 18.3076 4.10699 18.6004 4.39993C22.797 8.5978 22.797 15.4026 18.6004 19.6004C18.3076 19.8934 17.8327 19.8934 17.5398 19.6006C17.2468 19.3077 17.2467 18.8329 17.5396 18.5399C21.1506 14.9278 21.1506 9.07255 17.5396 5.46043C17.2467 5.16749 17.2468 4.69261 17.5398 4.39977ZM15.0098 7.92977C15.3027 7.63692 15.7776 7.63699 16.0704 7.92993C18.3151 10.1753 18.3151 13.8151 16.0704 16.0604C15.7776 16.3534 15.3027 16.3534 15.0098 16.0606C14.7168 15.7677 14.7167 15.2929 15.0096 14.9999C16.6687 13.3403 16.6687 10.6501 15.0096 8.99043C14.7167 8.69749 14.7168 8.22261 15.0098 7.92977ZM11.5315 4.41452C12.0226 4.02167 12.75 4.3713 12.75 5.00018V19.0002C12.75 19.6291 12.0226 19.9787 11.5315 19.5858L6.737 15.7502H3C2.6203 15.7502 2.30651 15.468 2.25685 15.1019L2.25 15.0002V9.00018C2.25 8.58596 2.58579 8.25018 3 8.25018H6.736L11.5315 4.41452ZM11.25 6.55918L7.46852 9.58583C7.33554 9.69221 7.1703 9.75018 7 9.75018H3.75V14.2502H7C7.13624 14.2502 7.26924 14.2873 7.38508 14.3566L7.46852 14.4145L11.25 17.4402V6.55918Z"
				/>
			</Svg>
		);
	}
);
SvgSpeakerOn24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgSpeakerOn24;
